module.exports = __webpack_public_path__ + "static/media/img-10.1026b2ab.jpg";